module.exports = __webpack_public_path__ + "static/media/research-deeply-understand.64c2705c.png";